export default {
  subscribeText: "Subscribe",
  upsellText: "Join the team"
};
